type ShippingFee = {
  id: number;
  name: string;
  fee: number;
};
const prefList: Array<ShippingFee> = [
  { id:0, name: "北海道", fee: 1370 },
  { id:1, name: "青森県", fee: 1040 },
  { id:2, name: "秋田県", fee: 1040 },
  { id:3, name: "岩手県", fee: 1040 },
  { id:4, name: "宮城県", fee: 930 },
  { id:5, name: "山形県", fee: 930 },
  { id:6, name: "福島県", fee: 930 },
  { id:7, name: "茨城県", fee: 930 },
  { id:8, name: "栃木県", fee: 930 },
  { id:9, name: "群馬県", fee: 930 },
  { id:10, name: "埼玉県", fee: 930 },
  { id:11, name: "千葉県", fee: 930 },
  { id:12, name: "神奈川県", fee: 930 },
  { id:13, name: "東京都", fee: 930 },
  { id:14, name: "山梨県", fee: 930 },
  { id:15, name: "新潟県", fee: 930 },
  { id:16, name: "長野県", fee: 930 },
  { id:17, name: "富山県", fee: 930 },
  { id:18, name: "石川県", fee: 930 },
  { id:19, name: "福井県", fee: 930 },
  { id:20, name: "静岡県", fee: 930 },
  { id:21, name: "愛知県", fee: 930 },
  { id:22, name: "三重県", fee: 930 },
  { id:23, name: "岐阜県", fee: 930 },
  { id:24, name: "大阪府", fee: 1040 },
  { id:25, name: "京都府", fee: 1040 },
  { id:26, name: "滋賀県", fee: 1040 },
  { id:27, name: "奈良県", fee: 1040 },
  { id:28, name: "和歌山県", fee: 1040 },
  { id:29, name: "兵庫県", fee: 1040 },
  { id:30, name: "岡山県", fee: 1150 },
  { id:31, name: "広島県", fee: 1150 },
  { id:32, name: "山口県", fee: 1150 },
  { id:33, name: "鳥取県", fee: 1150 },
  { id:34, name: "島根県", fee: 1150 },
  { id:35, name: "香川県", fee: 1150 },
  { id:36, name: "徳島県", fee: 1150 },
  { id:37, name: "愛媛県", fee: 1150 },
  { id:38, name: "高知県", fee: 1150 },
  { id:39, name: "福岡県", fee: 1370 },
  { id:40, name: "佐賀県", fee: 1370 },
  { id:41, name: "長崎県", fee: 1370 },
  { id:42, name: "熊本県", fee: 1370 },
  { id:43, name: "大分県", fee: 1370 },
  { id:44, name: "宮崎県", fee: 1370 },
  { id:45, name: "鹿児島県", fee: 1370 },
  { id:46, name: "沖縄県", fee: 1370 }, 
];

export const shippingFee = (pref: string) => {
  return prefList.filter(item=>item.name===pref)[0].fee
};

export const calcShippingFee = (subTotal:number, pref:string) =>{
  return subTotal >= 10000 ? 0 : shippingFee(pref);
}